// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"5":"accessLogs","152":"documentAccess","285":"documentUpload","571":"settings","593":"patients","981":"documents"}[chunkId] || chunkId) + "." + {"5":"6e7614cd","152":"4b6aaa46","235":"ea088a9b","285":"b7a9adf4","571":"87122d8d","593":"66f6c161","868":"f7462a04","981":"8495021f"}[chunkId] + ".css";
};